import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { DsPill } from '@frontend/ui/pill';

import { PillSize, PillVariant } from './ds-pill-attributes.types';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'cs-nav-pill',
    imports: [DsPill],
    templateUrl: './nav-pill.component.html',
    standalone: true,
    styleUrl: './nav-pill.component.scss',
})
export class NavPillComponent {
    label = input.required<string>();
    active = input(false);
    readonly pillClick = output<string>();

    variantStrong: PillVariant = PillVariant.STRONG;
    sizeMedium: PillSize = PillSize.MEDIUM;

    onClick() {
        this.pillClick.emit(this.label());
    }
}
